<app-material>
    <div class="header" header>
        <h2>{{ 'admin.issues.table.title' | translate }}</h2>
        <app-button *ngIf="shouldRenderModifiers()"
                    class="btn btn-primary btn-lg" style="float: right"
                    (click)="onDownloadIssuesReport()">
            {{ 'reportDownloadForm.downloadButton' | translate }}
        </app-button>
    </div>
    <ng-container body>
        <app-issue-table [issues]="issues"
                         [reasons]="reasons"
                         [tableConfig]="tableConfig"
                         [hasTitle]="false"
                         [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                         [isLoading]="isLoadingRoles || isLoadingIssues"
                         (sortChange)="onSortChange($event)"
                         (filterChange)="onFilter($event)"
                         (pageChange)="onPageChange($event)"
                         (rowClick)="onTableRowClick($event)">
        </app-issue-table>
    </ng-container>
</app-material>
<app-issue-create-modal>
</app-issue-create-modal>
